export const PAGE_SIZE = 12;
export const BLOG_SLUG = 'blog';
export const BLOG_LABEL = 'Blog';
export const UNCATEGORIZED_LABEL = 'Uncategorized';
export const FAVORITES_MODULE_FOR = 182;
export const TOURNAMENT_FAVORITES_MODULE_FOR = 4;
